import { useContext } from 'react'
import AuthorizationContext from './AuthorizationProvider.context'

/**
 * The authorization custom hook.
 */
export const useAuthorization = () => {
  const { isPrivated, userType, sellerDni } = useContext(AuthorizationContext)

  return { isPrivated, userType, sellerDni }
}
